<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
			<path
				class="regular"
				d="M0 64C0 77.3 10.7 88 24 88l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40C10.7 40 0 50.7 0 64zM0 192c0 13.3 10.7 24 24 24l302.4 0c18.8-22 43.4-38.8 71.5-48L24 168c-13.3 0-24 10.7-24 24zM0 320c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24zM0 448c0 13.3 10.7 24 24 24l373.9 0c-28.1-9.2-52.7-26-71.5-48L24 424c-13.3 0-24 10.7-24 24zM320 320c0 70.7 57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1l.1-.1 79.1 79.1c9.3 9.4 24.5 9.3 33.9 0s9.4-24.5 0-33.9l-79.1-79.1C567.8 371.4 576 346.7 576 320c0-70.7-57.3-128-128-128s-128 57.3-128 128zm48 0c0-28.6 15.2-55 40-69.3s55.2-14.3 80 0s40 40.7 40 69.3s-15.2 55-40 69.3s-55.2 14.3-80 0s-40-40.7-40-69.3z"
			/>
		</svg>
	</Icon>
</template>

<script setup>
import Icon, { regularProps } from './Icon'
defineOptions({ name: 'QuickSearchIcon' })
defineProps(regularProps)
</script>
